import React from 'react';

export const LoadingSpinner = ({ size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div className="flex items-center justify-center p-8">
      <div
        className={`${sizeClasses[size]} border-2 border-lux-border border-t-lux-gold rounded-full animate-spin`}
      />
    </div>
  );
};

export const PageLoader = () => (
  <div className="flex items-center justify-center min-h-[400px]">
    <div className="text-center">
      <div className="w-12 h-12 border-2 border-lux-border border-t-lux-gold rounded-full animate-spin mx-auto mb-4" />
      <p className="text-lux-muted">Loading...</p>
    </div>
  </div>
);

export const TableSkeleton = ({ rows = 5, cols = 6 }) => (
  <div className="animate-pulse">
    <div className="h-12 bg-lux-row rounded-t-lg mb-1" />
    {[...Array(rows)].map((_, i) => (
      <div key={i} className="h-16 bg-lux-card border-b border-lux-border/30 flex items-center px-6 gap-4">
        {[...Array(cols)].map((_, j) => (
          <div key={j} className="h-4 bg-lux-row rounded flex-1" />
        ))}
      </div>
    ))}
  </div>
);

export const CardSkeleton = () => (
  <div className="animate-pulse bg-lux-card border border-lux-border rounded-lg p-6">
    <div className="h-4 bg-lux-row rounded w-1/3 mb-4" />
    <div className="h-8 bg-lux-row rounded w-2/3" />
  </div>
);
